import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, AlertController, ViewController, NavParams } from 'ionic-angular';
import { DetailItemPage } from '../';
import { Master, Item, Assignment  } from '@providers/asset/index';

@Component({
  selector: 'page-select',
  templateUrl: 'page.html'
})
export class SelectPage {

  List  : any  = [];
  total_rows   = 0;
  total_page   = 0;
  currentPage  = 1;
  page_size    = 50;
  pilihModal   = 0;
  selectMod    = 0;
  vList        = 0;
  asset_location_id         : 0;
  asset_location_path_id    : 0;
  asset_classification_code : 0;
  project_code = '';
  assign  : 0;
  do_id   : 0;
  keyword = '';

  
  constructor(
    public navCtrl       : NavController,
    public masterApi     : Master,
    public assignmentApi : Assignment,
    public itemApi       : Item,
    public toastCtrl     : ToastController,
    public alertCtrl     : AlertController,
    public loadingCtrl   : LoadingController,
    public viewCtrl      : ViewController,
    public navParams     : NavParams
  ) {
    this.pilihModal                = navParams.get('pilihModal');
    this.selectMod                 = navParams.get('selectMod');
    this.asset_location_id         = navParams.get('asset_location_id');
    this.asset_location_path_id    = navParams.get('asset_location_path_id');
    this.project_code              = navParams.get('project_code');
    this.asset_classification_code = navParams.get('asset_classification_code');
    this.assign                    = navParams.get('assign');
    this.do_id                     = navParams.get('do_id');
  }

  ionViewDidEnter() {
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
    console.log(this.assign);
  }

  getList(keyword=''){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params:any = {};
    if(keyword!=''){
      params.keyword=keyword;
    }
    if(this.asset_location_id!=undefined){
      params.asset_location_id      = this.asset_location_id;
      params.asset_location_path_id = this.asset_location_path_id;
    }
    if(this.project_code!=undefined){
      params.project_code=this.project_code;
    }
    if(this.asset_classification_code!=undefined){
      params.asset_classification_code = this.asset_classification_code;
    }
    console.log("params select =>",params);
    
    if(this.selectMod==2){
      params.page     = this.currentPage;
      params.pageSize = 20;
      
      this.assignmentApi.getAssignee(params).subscribe((resp:any) => {
        this.List = resp.data;

        this.total_rows = resp.total_rows;
        this.total_page = this.total_rows/20;
        this.total_page = Math.ceil(this.total_page);
        loading.dismiss();
      }, (err) => {
        loading.dismiss();
      });
    }else if(this.selectMod==1){
      params.page     = this.currentPage;
      params.pageSize = this.page_size;

      this.itemApi.get(params).subscribe((resp:any) => {
        this.List       = resp.data;
        this.total_rows = resp.total_rows;
        this.total_page = this.total_rows/this.page_size;
        this.total_page = Math.ceil(this.total_page);
        loading.dismiss();
      }, (err) => {
        loading.dismiss();
      });
    }else if(this.selectMod==3){
      params.page     = this.currentPage;
      params.pageSize = 20;

      this.itemApi.getEmployee(params).subscribe((resp:any) => {
        this.List = resp.data;

        this.total_rows = resp.total_rows;
        this.total_page = this.total_rows/20;
        this.total_page = Math.ceil(this.total_page);
        loading.dismiss();
      }, (err) => {
        loading.dismiss();
      });
    }else if(this.selectMod==4){
      this.masterApi.getVendor(params).subscribe((resp:any) => {
        this.List = resp.data;
        loading.dismiss();
      }, (err) => {
        loading.dismiss(); 
      });
    }
  }


  select(item){
    let data = { item: item };
    if(this.assign==undefined){
      this.viewCtrl.dismiss(data);
      console.log(data);
    }else{
      this.navCtrl.push(DetailItemPage, {  id:item.id, do_id:this.do_id, assign:1  });
    }
  }

  onInput(e){
    this.getList(this.keyword);
  }

  onCancel(e){
    this.getList();
  }

  closeModal(){
    let data = {item:''};
    this.viewCtrl.dismiss(data);
  }

  first(){
    this.currentPage=1;
    this.getList();
  }
  last(){
    this.currentPage=this.total_page;
    this.getList();
  }
  next(){
    this.currentPage++;
    this.getList();
  }
  prev(){
    this.currentPage--;
    this.getList();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  saveVendor(vendor_name){
    let params = {
      vendor_name : vendor_name,
    }

    this.masterApi.postVendor(params).subscribe((resp:any) => {
      this.getList();
    });
  }

  addVendor(){
    let form = this.alertCtrl.create({
      title:'Form Vendor',
      inputs:[
        {
          name: 'vendor_name',
          placeholder:'Vendor Name'
        }
      ],
      buttons: [
        {
          text   : 'Cancel',
          role   : 'cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text   : 'Add',
          handler: data => {
            if (data.vendor_name!='') {
              console.log('vendor name => ', data.vendor_name);
              this.saveVendor(data.vendor_name);
            } else {
              this.presentToast('Nama Vendor tidak booleh kosong !');
              return false;
            }
          }
        }
      ]
    });
    form.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/select/page.ts